import {Pipe, PipeTransform} from '@angular/core';
import {AddSpacesPipe} from '../addSpaces/addSpaces.pipe';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'quantityInPcs',
  pure: false
})
export class QuantityInPcsPipe implements PipeTransform {
  constructor(private addSpacesPipe: AddSpacesPipe, private translateService: TranslateService) {}

  transform(value: number | string = 0) {
    if (typeof value === 'string') {
      value = parseInt(value, 0);
    }
    return this.addSpacesPipe.transform(value) + this.translateService.instant('general.api_cart_table_pcs');
  }
}
